import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconStarFilled = createSVG({
    children: (jsx("path", { d: "M8.112 8.23a1.04 1.04 0 0 0 .445-.188q.21-.164.328-.375l2.436-5.223q.21-.446.68-.446.47.001.68.446l2.436 5.223q.117.21.305.375.21.14.47.188l5.456.82q.47.07.61.539t-.188.797l-3.98 4.075a.93.93 0 0 0-.235.398 1.2 1.2 0 0 0-.047.47l.936 5.738q.095.492-.28.774a.72.72 0 0 1-.798.07l-4.872-2.693a.93.93 0 0 0-.984 0l-4.872 2.693a.71.71 0 0 1-.796-.07q-.376-.282-.28-.774l.935-5.739a.96.96 0 0 0-.023-.469.85.85 0 0 0-.258-.398l-3.982-4.076q-.33-.329-.188-.797.14-.469.61-.54l5.457-.817" })),
});

export { IconStarFilled };
